module.exports = __webpack_public_path__ + "static/media/ice02.d90f5590.webp";